/* generated by pull.js */
const manifest = {
  "unsupported": true,
  "editorOnly": true,
  "name": "Code Editor Tabbing",
  "description": "Adds tabs to the code editor, allowing you to divide many scripts from inside one sprite in to seperate parts.",
  "info": [],
  "credits": [
    {
      "name": "RedMan13",
      "link": "https://github.com/RedMan13"
    }
  ],
  "dynamicEnable": false,
  "dynamicDisable": false,
  "userscripts": [
    {
      "url": "userscript.js"
    }
  ],
  "userstyles": [
    {
      "url": "userstyle.css"
    }
  ],
  "settings": [
    {
      "type": "boolean",
      "id": "shouldDelete",
      "name": "Merge tabs on delete",
      "default": true,
      "description": "If we should keep blocks from deleted tabs, moving them into the new selected tab, or if we should delete blocks inside a deleted tab."
    },
    {
      "type": "boolean",
      "id": "moveOnDrag",
      "name": "Move blocks into tabs",
      "default": false,
      "description": "If, when blocks are dragged over a tab, we should copy blocks into the tab or move the selected blocks into the tab."
    }
  ],
  "tags": [],
  "enabledByDefault": false
};
export default manifest;
